<template>
  <div class="inner_content">
    <div class="header">
      <div class="flex">
        <el-button type="primary" size="small" @click="handle(1, 0)"
          >新建短信群发</el-button
        >
        <!-- <div>短信签名： 【智联同城】</div> -->
      </div>
    </div>
    <el-table
      :data="tableData"
      size="small"
      :header-cell-style="setHeader"
      height="100%"
    >
      <el-table-column type="index" :index="indexMethod"></el-table-column>
      <el-table-column
        prop="content"
        label="短信内容"
        width="140"
      ></el-table-column>
      <el-table-column prop="send_time" label="发送时间"> </el-table-column>
      <el-table-column prop="newStatus" label="发送状态"> </el-table-column>
      <el-table-column prop="mobile_num" label="发送短信人数">
      </el-table-column>
      <el-table-column prop="num" label="发送短信条数"> </el-table-column>
      <el-table-column prop="create_time" label="创建时间"> </el-table-column>
      <!-- <el-table-column prop="title" label="失败人数"> </el-table-column> -->

      <!-- <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-button size="mini" @click="handle(1, scope.row.id)"
            >重新发送</el-button
          >
          <el-button type="danger" size="mini" @click="handle(0, scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column> -->
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      layout="total, prev, pager, next, jumper"
      :total="total_num"
    >
    </el-pagination>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import time from "@/utils/time";
import { smsSendGroupLog } from "@/api/set";
export default {
  inject: ["reload"],
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      page: "0",
      total_num: 0,
      tableData: [],
      form: {
        value: true,
        name: "",
        region: ""
      },
      formLabelWidth: "120px",
      dialogFormVisible: false,
      options: [
        {
          value: "0",
          label: "全部状态"
        }
      ],
      value1: "",
      value: "",
      headerStyle: {
        background: "rgba(250,250,250,1)",
        color: "#000000"
      }
    };
  },
  mounted() {
    this.getData();
    console.log("time,", time);
  },
  methods: {
    indexMethod(index) {
      console.log("page", this.page, index);
      return index + 1 + (this.page - 1) * 10;
    },
    getData() {
      let data = {
        app_id: this.app_id,
        token: this.token,
        page: this.page
      };
      smsSendGroupLog(data).then(res => {
        if (res.code == 200) {
          this.tableData = res.data.data;
          this.total_num = res.data.total;
          this.page = res.data.current_page;

          this.tableData.forEach(item => {
            item.send_time = time.setTime(item.send_time);
            item.create_time = time.setTime(item.create_time);
            item.newStatus =
              item.status == 0
                ? "未发送"
                : item.status == 1
                ? "已发送"
                : "发送失败";
          });
        }
        console.log("数据", data);
      });
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getData();
    },
    // 设置表头颜色
    setHeader({ rowIndex }) {
      if (rowIndex === 0) {
        return this.headerStyle;
      } else {
        return "";
      }
    },
    handle(jude, id) {
      if (jude) {
        this.$router.push({
          path: `note-set`,
          query: {
            status: id
          }
        });
      } else {
        delAttention({
          app_id: this.app_id,
          token: this.token,
          id: id
        }).then(res => {
          if (res.code == 200) {
            this.$message.success("删除成功");
            this.reload();
          } else {
            this.$message.warning(res.msg);
          }
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.inner_content {
  background: #fff;
  padding: 0 24px;
  height: 100%;
  display: flex;
  flex-direction: column;
  font-size: 14px;
  .header {
    width: 100%;
    height: 72px;
    // margin-bottom: 20px;
    .box {
      width: 330px;
      .title {
        min-width: 100px;
        text-align: right;
      }
      .fixedwidth {
        width: 180px;
        display: flex;
        justify-content: space-between;
      }
    }
  }
  .el-table {
    flex: 1;
    overflow-y: auto;
  }
  .el-pagination {
    height: 60px;
    padding-top: 16px;
  }
}
// 通用样式
.flex {
  display: flex;
  align-items: center;
  padding: 10px 0px;
}
</style>
